import {
  EvaluationParameterDto,
  instanceOfEnumerationEvaluationParameterDto,
  instanceOfNumericEvaluationParameterDto,
} from '@/api/generator';
import { EMPTY_FIELD_SIGN } from '@/components/forms/utils';
import { I18nKey } from '@/utils/typings';
import { t } from 'i18next';
import { getSetupParameterName } from '../tasks/utils';

export function getEvaluationTypeString(
  evaluationParameter: EvaluationParameterDto,
  hideUnit?: boolean,
) {
  if (instanceOfNumericEvaluationParameterDto(evaluationParameter)) {
    const typeName = t(`EvaluationTypeEnum.${evaluationParameter.evaluationType}` as I18nKey);

    const unit = hideUnit ? '' : evaluationParameter.evaluationUnitAbbreviation;

    return typeName + (unit ? ` (${unit})` : '');
  } else {
    return EMPTY_FIELD_SIGN;
  }
}

export function getLimitTypeString(
  evaluationParameter: EvaluationParameterDto,
  hideUnit?: boolean,
) {
  if (instanceOfNumericEvaluationParameterDto(evaluationParameter)) {
    const typeName = t(`LimitType.${evaluationParameter.limitType}` as I18nKey);

    const unit = hideUnit ? '' : evaluationParameter.limitUnitAbbreviation;

    return typeName + (unit ? ` (${unit})` : '');
  } else {
    return EMPTY_FIELD_SIGN;
  }
}

export function getFullEvaluationTypeName(evaluationParameter?: EvaluationParameterDto) {
  if (instanceOfNumericEvaluationParameterDto(evaluationParameter)) {
    return `${getSetupParameterName(evaluationParameter)} - ${getEvaluationTypeString(evaluationParameter)}`;
  } else if (instanceOfEnumerationEvaluationParameterDto(evaluationParameter)) {
    return getSetupParameterName(evaluationParameter);
  } else {
    return '';
  }
}
